import {useMemo} from 'react';
import {getIsAdultBadge} from '../function';
import {IBadge} from '../type';

export default function useSplitAdultBadgeList(badges: IBadge[] = []) {
  const [adultBadges, otherBadges] = useMemo(
    () => [
      badges.filter(badge => getIsAdultBadge(badge)),
      badges.filter(badge => !getIsAdultBadge(badge)),
    ],
    [badges]
  );

  return {adultBadges, otherBadges};
}
